/*------------------------------------*\
    MODULES
\*------------------------------------*/
import $ from "jquery";

/*------------------------------------*\
    SMOOTH SCROLL
\*------------------------------------*/
class SmoothScroll {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.anchors = self.elem.querySelectorAll('a');
        self.offset = self.elem.clientHeight;
    }

    init() {
        let self = this;

        for (var anchor of Object.values(self.anchors)) {

            anchor.addEventListener('click', function(event) {
                event.preventDefault();
                
                var dropdown = document.getElementById("stallion-profile-nav-list");
                dropdown.classList.remove("show");

                var toggle = document.getElementById("stallion-profile-nav-toggle");
                toggle.classList.remove("collapsed");
                
                self.smoothScroll(this.dataset.target);
            })
        }
    }

    smoothScroll(target) {
        let self = this;
        let targetElement = document.querySelector(target);

        let bodyRect = document.body.getBoundingClientRect().top;
        let elementRect = targetElement.getBoundingClientRect().top;
        let elementPosition = elementRect - bodyRect;
        var offsetPosition = elementPosition - self.offset;

        if($(window).width() > 1500) {
            var offsetPosition = elementPosition - self.offset - 78;
        } else if($(window).width() < 992) {
            var offsetPosition = elementPosition - self.offset + 44;
        }

        $('body,html').animate({
            scrollTop: offsetPosition
        }, 1000);
    }

}

export default SmoothScroll;
